import Stack from '@zenbusiness/zui/Stack';
import { superstyled } from '@zenbusiness/zui/styles';

export const PasswordRow = superstyled({
  tag: Stack,
  name: 'SignInSecurity',
  slot: 'PasswordRow',
  styles: ({ theme }) => ({
    gap: theme.spacing(2),
    alignItems: 'flex-start',

    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
  }),
});
